export const grantConsent = () => {
  const { gtag } = useGtag();
  gtag('consent', 'update', {
    analytics_storage: 'granted',
  });
};

export default defineNuxtPlugin(() => {
  window.addEventListener('pointerdown', grantConsent, { once: true });
  window.addEventListener('keydown', grantConsent, { once: true });
  window.addEventListener('scroll', grantConsent, {
    once: true,
    passive: true,
    capture: true,
  });
});
